import React, { useState } from 'react';
import styled from 'styled-components';

const IAOfficersAdd = ({ onClose }) => {
  const [formData, setFormData] = useState({
    last_name: '',
    first_name: '',
    middle_name: '',
    phone_number: '',
    email: '',
    address: '',
    date_of_birth: '',
    name_of_spouse: '',
    position: '',
    appointment_year: '',
    tin: '',
    motto: '',
    photo: null,
  });

  const provinces = ['Bohol', 'Cebu', 'Leyte', 'Negros Occidental', 'Samar'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, photo: file });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    onClose();
  };

  return (
    <FormPanel>
      <FormHeader>
        <Title>Add IA Officer</Title>
        <Icons>
          <CloseBtn onClick={onClose}>✖</CloseBtn>
        </Icons>
      </FormHeader>
      <FormBody>
        <Row>
          <Field>
            <Label>Last Name</Label>
            <Input name="last_name" value={formData.last_name} onChange={handleChange} />
          </Field>
          <Field>
            <Label>First Name</Label>
            <Input name="first_name" value={formData.first_name} onChange={handleChange} />
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>Middle Name</Label>
            <Input name="middle_name" value={formData.middle_name} onChange={handleChange} />
          </Field>
          <Field>
            <Label>Phone Number</Label>
            <Input name="phone_number" value={formData.phone_number} onChange={handleChange} />
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>Email</Label>
            <Input type="email" name="email" value={formData.email} onChange={handleChange} />
          </Field>
          <Field>
            <Label>Address</Label>
            <Select name="address" value={formData.address} onChange={handleChange}>
              <option value="">Select Province</option>
              {provinces.map((prov) => (
                <option key={prov} value={prov}>{prov}</option>
              ))}
            </Select>
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>Date of Birth (mm/dd/yy)</Label>
            <Input type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} />
          </Field>
          <Field>
            <Label>Name of Spouse</Label>
            <Input name="name_of_spouse" value={formData.name_of_spouse} onChange={handleChange} />
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>Position</Label>
            <Input name="position" value={formData.position} onChange={handleChange} />
          </Field>
          <Field>
            <Label>Appointment Year</Label>
            <Input name="appointment_year" value={formData.appointment_year} onChange={handleChange} />
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>TIN</Label>
            <Input name="tin" value={formData.tin} onChange={handleChange} />
          </Field>
          <Field>
            <Label>Motto</Label>
            <Input name="motto" value={formData.motto} onChange={handleChange} />
          </Field>
        </Row>

        <Field>
          <Label>Photo</Label>
          <Input type="file" accept="image/*" onChange={handlePhotoChange} />
        </Field>
      </FormBody>

      <FormFooter>
        <AddButton onClick={handleSubmit}>Add Officer</AddButton>
      </FormFooter>
    </FormPanel>
  );
};

export default IAOfficersAdd;

const FormPanel = styled.div`
  width: 700px;
  max-height: 90vh;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const FormHeader = styled.div`
  background-color: #2e7d32;
  color: white;
  padding: 5px 20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
`;

const Icons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CloseBtn = styled.button`
  background: none;
  color: white;
  font-size: 20px;
  border: none;
  cursor: pointer;

  &:hover {
    color: #ffdede;
  }
`;

const FormBody = styled.div`
  padding: 10px 20px 20px;
  overflow-y: auto;
  flex-grow: 1;
`;

const FormFooter = styled.div`
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  background-color: #f9f9f9;
`;

const AddButton = styled.button`
  padding: 10px 20px;
  background-color: #2e7d32;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: #27672a;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;

  & > div {
    flex: 1;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 13px;
  margin-bottom: 4px;
  color: #555;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;

  &:focus {
    outline: none;
    border-color: #4caf50;
    box-shadow: 0 0 4px rgba(76, 175, 80, 0.3);
  }
`;

const Select = styled.select`
  padding: 10px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;

  &:focus {
    outline: none;
    border-color: #4caf50;
    box-shadow: 0 0 4px rgba(76, 175, 80, 0.3);
  }
`;
